<div class="sm-options-content-layout flex-row-split height100p" [class.mobile]="mobile" [class.can-collapse]="canCollapse" [class.options-open]="optionsVisible" [class.mobile-mode-overlay]="mobileMode == 'overlay'" [class.mobile-mode-push]="mobileMode == 'push'" [style.--sm-options-content-layout-rail-width]="collapsedBarWidth">
    @if (toggleVisible) {
        <div class="sm-options-content-layout-rail flex-item-fixed">
            <p-button class="sm-options-content-layout-toggle-wrapper" styleClass="sm-options-content-layout-toggle" [icon]="toggleIcon" [rounded]=true [text]=true [pTooltip]="toggleTooltip" tooltipPosition="right" (onClick)="toggleOptions()"></p-button>
        </div>
    }

    @if (overlayOptionsVisible && closeOnBackdropClick) {
        <div class="sm-options-content-layout-backdrop" (click)="closeOptions()"></div>
    }

    @if (inlineOptionsVisible || overlayOptionsVisible) {
        <div class="sm-options-content-layout-options flex-item-fixed height100p full-height flex-col" [ngClass]="[optionsWidthClass, optionsStyleClass, overlayOptionsVisible ? 'overlay-options' : '']">
            <ng-container *ngTemplateOutlet="options"></ng-container>
        </div>
    }

    <div class="sm-options-content-layout-content flex-item-fill height100p" [ngClass]="contentStyleClass" (click)="contentClicked()">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
</div>
